import { AxiosHeaders, AxiosRequestConfig } from 'axios';

/**
 * Client-only signal, carried on a standard request header (not a made-up axios config
 * field), that tells the global http interceptor to skip its error toast for a request.
 * The caller then owns the error UX — e.g. a react-query query that retries and surfaces
 * the final error itself via its own onError.
 */
export const SUPPRESS_ERROR_TOAST_HEADER = 'X-Suppress-Error-Toast';

export const suppressErrorToastHeader = (): Record<string, string> => ({
  [SUPPRESS_ERROR_TOAST_HEADER]: 'true',
});

export const isErrorToastSuppressed = (config?: AxiosRequestConfig): boolean => {
  const { headers } = config ?? {};

  if (!headers) {
    return false;
  }

  // On the response error the config carries an AxiosHeaders instance; a plain object is
  // handled too so the check is robust wherever it is called from.
  if (headers instanceof AxiosHeaders) {
    return headers.get(SUPPRESS_ERROR_TOAST_HEADER) === 'true';
  }

  return (headers as Record<string, unknown>)[SUPPRESS_ERROR_TOAST_HEADER] === 'true';
};
